import * as React from 'react';
const LayoutModeContext = React.createContext(null);
export const LayoutModeProvider = ({ layoutMode, setLayoutMode, children }) => {
    const value = React.useMemo(() => ({ layoutMode, setLayoutMode }), [layoutMode, setLayoutMode]);
    return React.createElement(LayoutModeContext.Provider, { value: value }, children);
};
export function useLayoutMode() {
    return React.useContext(LayoutModeContext).layoutMode;
}
export function useSetLayoutMode() {
    return React.useContext(LayoutModeContext).setLayoutMode;
}
